import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';

import { Store } from '@ngrx/store';

import { BetslipType } from '../../../../../../core/betslip-type';
import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { selectPickErrorsForTypeFactory } from '../../../../../validation/selectors';
import { groupPickHasWarning, isErrorComboPrevention } from '../../../../../validation/services/utils/betslip-errors-utils';
import { BetBuilderPick } from '../../../../models';

@Component({
    selector: 'bs-linear-bet-builder-warning-indicator',
    templateUrl: './linear-bet-builder-warning-indicator.component.html',
    styleUrls: ['./linear-bet-builder-warning-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class LinearBetBuilderWarningIndicatorComponent {
    readonly pick = input.required<BetBuilderPick>();

    readonly showIndicator: Signal<boolean>;

    constructor(store: Store) {
        const pickErrors = store.selectSignal(selectPickErrorsForTypeFactory(BetslipType.BetBuilder));

        this.showIndicator = computed(() => {
            const errors = pickErrors();
            const pick = this.pick();

            if (BaseBetslipGroupPick.isPick(pick) && pick.groupHasUncombinableLeg()) {
                return false;
            }

            return !!errors[pick.id.toString()]?.some((error) => isErrorComboPrevention(error) || groupPickHasWarning(error));
        });
    }
}
